<div class="products">
  <div class="container">
    <div class="products__header">
      <div class="products__header--title">Events Nearby</div>
      <button type="button" class="products__header--button-2" (click)="add()"
        *ngIf="roleService.roles.userType.includes('ADMIN')">
        Add
      </button>

      <!-- <button type="button" class="products__header--button-2" title="If u want to list an event contact us!"
        *ngIf="!roleService.roles.userType.includes('ADMIN')">
        <i class="fa fa-lock" aria-hidden="true"></i> Add
      </button> -->
    </div>
    <div class="grid">
      <div class="my-card" *ngFor="let list of allEvents; let i = index">
        <div class="image">
          <img loading="lazy" [src]="imgUrl + list.image" class="pro" (click)="view(viewEvent, list)" />
        </div>
        <div class="detail">
          <div>
            <div class="detail_title">
              {{ list.name.substr(0, 40)
              }}<span *ngIf="list.name.length > 40">...</span>
            </div>
            <!-- <div>{{list?.eventCreatedBy}}</div> -->
            <div class="desc">
              {{ list.description.substr(0, 80)
              }}<span *ngIf="list.description.length > 80">...</span>
            </div>
          </div>
          <div class="bottom">
            <div>
              <div class="item">
                <i class="fa-solid fa-users"></i> {{ list?.registeredMembers }}
              </div>
              <div class="item">
                <i class="fa fa-map-marker" aria-hidden="true"></i>
                {{ list?.subRegion.join(', ') | titlecase }}
              </div>
            </div>
            <button class="button-2" (click)="join(list.id)">Join</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #viewEvent let-modal>
  <div class="modal-event">
    <div class="modal-event__close" (click)="modal.dismiss('Cross click')">
      <i class="fa-solid fa-times"></i>
    </div>
    <img loading="lazy" [src]="imgUrl + selectedEvent.image" class="pro" style="width: inherit" />
    <div class="modal-body">
      <h5>
        {{ selectedEvent.name }}
      </h5>
      <div class="modal-event__meta">
        <div>
          <b> Date Event:</b>
          {{ convertDate(selectedEvent?.eventDate) }}
        </div>
        <div>
          <b>Interest: </b>
          {{ selectedEvent?.registeredMembers }}
        </div>
        <div>
          <b>Region:</b>
          {{ selectedEvent?.subRegion | titlecase }}
        </div>
      </div>
      <!-- <app-timer [eventDate]="selectedEvent?.eventDate"></app-timer> -->

      <div>{{ selectedEvent?.description }}</div>
      <button class="button-2" (click)="goto(selectedEvent.url)">
        GO TO EVENT <i class="fa fa-arrow-right" aria-hidden="true"></i>
      </button>
    </div>
  </div>
</ng-template>

<app-manage-events #ManageEvents [hideAll]="true" (updated)="getAllEvents()"></app-manage-events>